import React, { lazy, Suspense } from 'react';
import { Link } from 'react-router-dom';

import { getLogoURL } from 'components/utils/app';

const MobileMenu = lazy(() => import(/* webpackChunkName: "mobile-menu" */ 'components/layout/header/mobile-menu'));
const TopMenu = lazy(() => import(/* webpackChunkName: "top-menu" */ 'components/layout/header/top-menu'));

const Header = () => {
  //logInfo('RENDER: Header');

  return (
    <header>
      <Link to="/" title="Homepage" className="header-logo">
        <img src={getLogoURL()} alt="Birthday Alarm Logo" width="189" height="31" />
        {BDAY_ENV && BDAY_ENV !== 'prod' ? <span className="header-env-name">{BDAY_ENV}</span> : null}
      </Link>
      <Suspense fallback={null}>
        <MobileMenu/>
      </Suspense>
      <Suspense fallback={null}>
        <TopMenu/>
      </Suspense>
    </header>
  );
}

export default Header;
